import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpResponse } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { SpinnerService } from './spinner.service';
import { LoaderService } from './loader/loader.service';
 
@Injectable()
export class SpinnerHttpInterceptor implements HttpInterceptor {

     constructor(private spinnerService: SpinnerService,
        private loaderService: LoaderService) { }
 
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
 
        this.loaderService.show();
        console.log("Showing");
        return next
            .handle(req)
            .pipe(
                tap((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        this.loaderService.hide();
                        console.log("Hide");
                    }
                }, (error) => {
                    this.loaderService.hide();
                    console.log("Hide");
                })
            );
    }
}